import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ResourcesRequestsService} from "../../services/resources-requests.service";

export class resourcesMultipleSelectCtrl implements IController {
  resources: any;
  resourceIds: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedResources: any;

  constructor(private $mdSelect, private resourcesRequestsService: ResourcesRequestsService) {
  }

  $onInit() {
    if (_.get(this.resourceIds, 'length')) {
      this.resourcesRequestsService.getResourcesByIds(this.resourceIds)
        .then((resources) => {
          this.resources = resources;
          this._setSelectedResources();
        })
    } else {
      this._setSelectedResources();
    }

    if (!this.options) {
      this.resourcesRequestsService.getResourcesByIds()
        .then((options) => {
          this.options = options;
        })
    }
  }

  $onChanges(changes) {
    if (changes.resources && !changes.resources.isFirstChange()) {
      this._setSelectedResources();
    }
  };

  reset() {
    this.selectedResources = [];
    this.onChange({resources: []});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide({resources: this.resources});
  }

  select() {
    this.onChange({resources: this.selectedResources});
    this.$mdSelect.hide();
  }

  private _setSelectedResources() {
    this.selectedResources = angular.copy(this.resources);
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourcesMultipleSelect', {
    bindings: {
      resources: '<',
      resourceIds: '<?',
      options: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./resources-multiple-select.html').default,
    controller: resourcesMultipleSelectCtrl
  });
